import type { PropsWithChildren } from 'react'

import { type UploadCommonProps } from '../../Upload'
import { EmptyState } from '@ui/blocks/EmptyState'

export interface IUploadEmptyStateProps {
  commonProps: UploadCommonProps
  innerProps: {
    maxFileSize: string
  }
}

export const UploadEmptyState = ({
  commonProps,
  innerProps = {
    maxFileSize: null,
  },
}: PropsWithChildren<IUploadEmptyStateProps>) => {
  const { maxFileSize } = innerProps

  const emptyStateText = `${commonProps.strings.emptyStateInfo} ${
    maxFileSize && !commonProps.isReadonly
      ? `(max file size ${maxFileSize})`
      : ''
  }`

  return (
    <EmptyState
      small
      header={emptyStateText}
      context={commonProps.isReadonly ? 'file' : 'activity'}
    />
  )
}
